export const MOZART_API_PATH = Object.freeze({
  ALL_NOTIFICATIONS: 'api/rs-aliados-gateway/groot/partners/notifications',
  NOTIFICATION_SEEN_BY_ID:
    'api/rs-aliados-gateway/groot/partners/notifications/seen/:id',
  TURN_OFF_PRODUCT:
    'api/rs-aliados-gateway/groot/partners/proxy/menu/products/available/false',
} as const);
